<div class="input-frame" :class="{ 'is-alert': errorTest }">
    <label class="label" :for="inputId" :data-text="label">
        <span>{{ label }}</span>
    </label>
    <div class="form-group">
        <div>
            <input :type="type" :id="inputId" :ref="inputId"
                   :value="value" @input="handleInput($event.target.value)"
                   :placeholder="placeholder" :title="title" :readonly="readonly"/>
        </div>
        <button-action
            default-class="" class="input-like form-group-input is-flex-fixed misc-trigger"
            :title="buttonTitle"
            @click.native="handleAction" :loading="loading" :disabled="disabled">
            <svg width="1em" class="svg-middle misc-trigger-arrow" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
                <use :href="iconHref"/>
            </svg>
            <span class="rwd-over-medium">  {{ buttonLabel }}</span>
        </button-action>
    </div>
    <div class="msg-alert" v-if="displayError" v-show="errorTest">
        <div class="msg-alert-inner">{{ errorMsg }}</div>
    </div>
</div>
